import { http } from './http';
import type {
  Group,
  CreateGroupRequest,
  UpdateGroupRequest,
  GetGroupsResponse,
} from '@daynote/shared-types';

export const groupApi = {
  list: () => http.get<unknown, GetGroupsResponse>('/groups'),
  create: (data: CreateGroupRequest) => http.post<unknown, Group>('/groups', data),
  update: (id: string, data: UpdateGroupRequest) =>
    http.patch<unknown, Group>(`/groups/${id}`, data),
  remove: (id: string) => http.delete(`/groups/${id}`),
};
